import {computed, makeObservable} from 'mobx';

import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {PredictionOptionDomainModel} from "./option/prediction-option.domain-model";
import {PredictionsWidgetVoteViewModel} from "../../../../widgets/prediction-widget/models/predictions-widget.vote-view-model";
import {PREDICTION_ANIMATION_ARGS} from "../../../../core/consts";

export class PredictionsOptionViewModel extends BaseViewModel {
  domainModel: PredictionOptionDomainModel;
  selectedVoteNum: Number;
  delayMS: Number;

  constructor(domainModel: PredictionOptionDomainModel, selectedVoteNum: Number, delayMS: Number) {
    super(domainModel);

    this.selectedVoteNum = selectedVoteNum;
    this.delayMS = delayMS;

    makeObservable(this);
  }

  get num(): String {
    return this.domainModel.num;
  }

  get name(): String {
    return this.domainModel.name;
  }

  @computed get vote(): PredictionsWidgetVoteViewModel {
    return new PredictionsWidgetVoteViewModel(this.domainModel.vote);
  }

  @computed get isSelected(): Boolean {
    return this.selectedVoteNum === this.num;
  }

  @computed get animationDuration(): Number {
    const duration = this.domainModel.apiModel.vote.percentage * PREDICTION_ANIMATION_ARGS.multiplyToMs;

    return duration;
  }
}
